var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Box } from '@material-ui/core';
import MaterialMenuItem from '@material-ui/core/MenuItem';
import 'react';
import { Accept } from '@abdt/icons';
import { colors } from '@abdt/design-tokens';
var gray100 = colors.gray100, gray350 = colors.gray350, neon600 = colors.neon600, grass550 = colors.grass550;
var styles = function () { return ({
    root: {},
}); };
var useStyles = makeStyles(styles);
var useListItemStyles = makeStyles(function () { return ({
    root: {
        fontSize: '14px',
        padding: '20px 24px',
        display: function (props) {
            return props.checked ? 'flex' : '';
        },
        justifyContent: function (props) {
            return props.checked ? 'space-between' : '';
        },
        position: 'relative',
        '& > svg': {
            flexShrink: 0,
            position: 'absolute',
            top: '20px',
            right: '16px',
        },
        '& > .MuiBox-root': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
        },
    },
    button: {
        '&:active': {
            backgroundColor: '#d3f9f2',
            color: neon600,
        },
    },
    disabled: {
        backgroundColor: gray100,
        '& > svg path': {
            fill: gray350,
        },
    },
}); });
var MenuItem = function (_a) {
    var children = _a.children, _b = _a.checked, checked = _b === void 0 ? false : _b, props = __rest(_a, ["children", "checked"]);
    var rootClasses = useStyles();
    var listItemClasses = useListItemStyles({ checked: checked });
    return (React.createElement(MaterialMenuItem, __assign({}, props, { classes: rootClasses, ListItemClasses: listItemClasses, disableRipple: true, divider: true }),
        React.createElement(Box, null, children),
        checked && React.createElement(Accept, { color: grass550 })));
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map